import {SUPERBET_IN_PROCESS} from "../actions/actionTypes";

const SuperbetInProcess = (state = false, action) => {
    switch (action.type) {
        case SUPERBET_IN_PROCESS:
            return action.payload;
        default:
            return state;
    }
};

export default SuperbetInProcess;